(function () {
  'use strict';

  /*
   * Central promotion configuration.
   * Do not publish with a null reward variant when that reward is advertised.
   * Every configured gift must also be protected by a Shopify server-side
   * automatic discount (or a true $0 price). Client code is never the price
   * or entitlement authority.
   */
  var CONFIG = {
    campaign: 'Gen Con Sale 2026',
    promotionEndsAtUtc: Date.parse('2026-09-02T04:59:59Z'),
    fetchTimeoutMs: 6000,
    eligibilityFetchAttempts: 3,
    debounceMs: 120,
    rewardRule: 'gencon-2026-v4-single-server-enforced-reward-unit',
    collections: {
      spindown: 'gen-con-free-spindown-eligible',
      poly: 'polyhedral-dice-sets'
    },
    gifts: [
      {
        key: 'spindown',
        label: 'free Spindown d20',
        variantId: 54683413250327,
        propertyKey: '_gencon_free_spindown',
        propertyValue: 'Gen Con Sale 2026'
      },
      {
        key: 'polyReward',
        label: 'mystery reward unit',
        variantId: 54682715717911,
        propertyKey: '_gencon_mystery_reward',
        propertyValue: 'Gen Con Sale 2026'
      },
      {
        key: 'legacyMysteryDie',
        label: 'legacy mystery die line',
        variantId: 54680536318231,
        propertyKey: '_gencon_mystery_die',
        propertyValue: 'Gen Con Sale 2026'
      },
      {
        key: 'legacyMysterySlipcase',
        label: 'legacy mystery slipcase line',
        variantId: 54680536219927,
        propertyKey: '_gencon_mystery_slipcase',
        propertyValue: 'Gen Con Sale 2026'
      },
      {
        key: 'legacyManagedSpindown',
        label: 'legacy managed Spindown line',
        variantId: 51535107227927,
        propertyKey: '_gencon_free_spindown',
        propertyValue: 'Gen Con Sale 2026',
        managedOnlyCleanup: true
      }
    ],
    informationalAttributeKey: 'Gen Con promotion audit note',
    informationalAttributeValue: 'Informational only - each reward unit means 1 mystery die; pack 1 slipcase per 3 units; verify from paid qualifying sets'
  };

  var LEGACY_ATTRIBUTE_KEYS = [
    'Gen Con reward rule',
    'Mystery bonus dice',
    'Mystery slipcases',
    'Spindown entitlements'
  ];
  var collectionPromises = {};
  var reconcilePromise = null;
  var pending = false;
  var timer = null;
  var checkoutPromise = null;
  var checkoutPreparing = false;
  var checkoutBypassForm = null;
  var bootstrap = window.InfiniteBlackPromotionBootstrap || {};
  var serverRenderedAtMs = Number(bootstrap.renderedAtEpochMs || 0);
  var localLoadedAtMs = Date.now();
  var localLoadedAtMonotonicMs = window.performance && typeof window.performance.now === 'function'
    ? window.performance.now()
    : null;

  function elapsedSinceLoadMs() {
    if (localLoadedAtMonotonicMs !== null) {
      return Math.max(window.performance.now() - localLoadedAtMonotonicMs, 0);
    }
    return Math.max(Date.now() - localLoadedAtMs, 0);
  }

  function serverNowMs() {
    return serverRenderedAtMs > 0
      ? serverRenderedAtMs + elapsedSinceLoadMs()
      : Date.now();
  }

  function endpoint(name, fallback) {
    return window.theme && window.theme.routes && window.theme.routes[name]
      ? window.theme.routes[name]
      : fallback;
  }

  function requestHeaders() {
    return {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json'
    };
  }

  function fetchWithTimeout(url, options) {
    var timeoutMs = CONFIG.fetchTimeoutMs;
    var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var timeoutId;
    var requestOptions = options || {};

    if (controller) {
      requestOptions = Object.assign({}, requestOptions, { signal: controller.signal });
      timeoutId = window.setTimeout(function () { controller.abort(); }, timeoutMs);
      return fetch(url, requestOptions).then(function (response) {
        window.clearTimeout(timeoutId);
        return response;
      }, function (error) {
        window.clearTimeout(timeoutId);
        if (error && error.name === 'AbortError') throw new Error('The promotion service timed out.');
        throw error;
      });
    }

    return Promise.race([
      fetch(url, requestOptions),
      new Promise(function (_, reject) {
        timeoutId = window.setTimeout(function () {
          reject(new Error('The promotion service timed out.'));
        }, timeoutMs);
      })
    ]).then(function (response) {
      window.clearTimeout(timeoutId);
      return response;
    }, function (error) {
      window.clearTimeout(timeoutId);
      throw error;
    });
  }

  function isPromotionActive() {
    return Boolean(bootstrap.activeAtRender) && serverNowMs() < CONFIG.promotionEndsAtUtc;
  }

  function schedulePromotionExpiryRefresh() {
    var remaining = CONFIG.promotionEndsAtUtc - serverNowMs();
    if (remaining <= 0 || !document.querySelector('[data-ib-cart-root], #CartDrawer, .shopify-payment-button')) return;
    var delay = Math.min(Math.max(remaining, 0), 2147483000);
    window.setTimeout(function () {
      if (!isPromotionActive()) {
        window.location.reload();
      } else {
        schedulePromotionExpiryRefresh();
      }
    }, delay);
  }

  function loadCollectionProductIds(handle) {
    if (collectionPromises[handle]) return collectionPromises[handle];

    var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250';
    function attempt(attemptNumber) {
      return fetchWithTimeout(url, {
        credentials: 'same-origin',
        method: 'GET',
        cache: 'no-store',
        headers: { 'Accept': 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Could not load promotion eligibility.');
        return response.json();
      }).then(function (data) {
        var ids = {};
        (data.products || []).forEach(function (product) {
          ids[String(product.id)] = true;
        });
        return ids;
      }).catch(function (error) {
        if (attemptNumber >= CONFIG.eligibilityFetchAttempts) throw error;
        return new Promise(function (resolve) {
          window.setTimeout(resolve, attemptNumber * 250);
        }).then(function () {
          return attempt(attemptNumber + 1);
        });
      });
    }

    collectionPromises[handle] = attempt(1).catch(function (error) {
      delete collectionPromises[handle];
      throw error;
    });

    return collectionPromises[handle];
  }

  function configuredVariantId(gift) {
    var id = Number(gift && gift.variantId);
    return Number.isFinite(id) && id > 0 ? id : null;
  }

  function isManagedGiftLineFor(item, gift) {
    var variantId = configuredVariantId(gift);
    return Boolean(variantId)
      && Number(item && item.variant_id) === variantId
      && item.properties
      && item.properties[gift.propertyKey] === gift.propertyValue;
  }

  function isGiftVariantLineFor(item, gift) {
    if (gift && gift.managedOnlyCleanup) return isManagedGiftLineFor(item, gift);
    var variantId = configuredVariantId(gift);
    return Boolean(variantId) && Number(item && item.variant_id) === variantId;
  }

  function isAnyGiftVariantLine(item) {
    return CONFIG.gifts.some(function (gift) { return isGiftVariantLineFor(item, gift); });
  }

  function managedGiftLines(cart, gift) {
    return (cart.items || []).filter(function (item) { return isManagedGiftLineFor(item, gift); });
  }

  function giftVariantLines(cart, gift) {
    return (cart.items || []).filter(function (item) { return isGiftVariantLineFor(item, gift); });
  }

  function eligibleQuantity(cart, productIds) {
    return (cart.items || []).reduce(function (total, item) {
      if (isAnyGiftVariantLine(item)) return total;
      return productIds[String(item && item.product_id)] === true
        ? total + Number(item.quantity || 0)
        : total;
    }, 0);
  }

  function desiredGiftQuantities(cart, eligibility) {
    if (!isPromotionActive()) {
      return { spindown: 0, polyReward: 0, legacyMysteryDie: 0, legacyMysterySlipcase: 0, legacyManagedSpindown: 0 };
    }
    var spindownCount = eligibleQuantity(cart, eligibility.spindown || {});
    var polyCount = eligibleQuantity(cart, eligibility.poly || {});
    return {
      spindown: spindownCount,
      polyReward: polyCount,
      legacyMysteryDie: 0,
      legacyMysterySlipcase: 0,
      legacyManagedSpindown: 0
    };
  }

  function getCart() {
    return fetchWithTimeout(endpoint('cart', '/cart.js') + '?t=' + Date.now(), {
      credentials: 'same-origin',
      method: 'GET',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not read the cart.');
      return response.json();
    });
  }

  function updateCartAttributes() {
    var attributes = {};
    LEGACY_ATTRIBUTE_KEYS.forEach(function (key) { attributes[key] = ''; });
    attributes[CONFIG.informationalAttributeKey] = CONFIG.informationalAttributeValue;
    return fetchWithTimeout('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: requestHeaders(),
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not save the informational promotion audit note.');
      return response.json();
    });
  }

  function updateGiftLines(updates) {
    return fetchWithTimeout('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: requestHeaders(),
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not reconcile promotional gift quantities.');
      return response.json();
    });
  }

  function addGiftLines(items) {
    return fetchWithTimeout(endpoint('cartAdd', '/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: requestHeaders(),
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || 'Could not add promotional gifts.');
        });
      }
      return response.json();
    });
  }

  function giftProperties(gift) {
    var properties = {};
    properties[gift.propertyKey] = gift.propertyValue;
    return properties;
  }

  function buildReconciliationPlan(cart, desired) {
    var updates = {};
    var additions = [];
    var missingConfiguration = [];

    CONFIG.gifts.forEach(function (gift) {
      var desiredQuantity = Number(desired[gift.key] || 0);
      var variantId = configuredVariantId(gift);
      if (!variantId) {
        if (desiredQuantity > 0) missingConfiguration.push(gift.label);
        return;
      }

      var allVariantLines = giftVariantLines(cart, gift);
      var lines = allVariantLines.filter(function (item) { return isManagedGiftLineFor(item, gift); });
      allVariantLines.forEach(function (item) {
        if (!isManagedGiftLineFor(item, gift)) updates[item.key] = 0;
      });
      if (!lines.length && desiredQuantity > 0) {
        additions.push({
          id: variantId,
          quantity: desiredQuantity,
          properties: giftProperties(gift)
        });
        return;
      }

      if (lines.length) {
        if (Number(lines[0].quantity || 0) !== desiredQuantity) {
          updates[lines[0].key] = desiredQuantity;
        }
        for (var index = 1; index < lines.length; index += 1) {
          updates[lines[index].key] = 0;
        }
      }
    });

    return {
      updates: updates,
      additions: additions,
      missingConfiguration: missingConfiguration
    };
  }

  function cartSignature(cart) {
    return (cart.items || []).map(function (item) {
      return [
        String(item.key || item.variant_id || ''),
        Number(item.quantity || 0),
        Number(item.final_line_price || 0),
        Number(item.total_discount || 0)
      ].join(':');
    }).sort().join('|') + '::' + String(Number(cart.total_price || 0));
  }

  function auditAttributeMatches(cart) {
    return String((cart.attributes || {})[CONFIG.informationalAttributeKey] || '')
      === CONFIG.informationalAttributeValue;
  }

  function hasLegacyAuthoritativeAttributes(cart) {
    var attributes = cart.attributes || {};
    return LEGACY_ATTRIBUTE_KEYS.some(function (key) {
      return String(attributes[key] || '') !== '';
    });
  }

  function giftLineIsFree(item) {
    var finalLinePrice = Number(item.final_line_price || 0);
    var originalLinePrice = item.original_line_price == null
      ? Number(item.line_price == null ? finalLinePrice : item.line_price)
      : Number(item.original_line_price);
    var allocationAmount = (item.discount_allocations || []).reduce(function (total, allocation) {
      return total + Number(allocation.amount || 0);
    }, 0);
    var discountAmount = Math.max(Number(item.total_discount || 0), allocationAmount);
    return finalLinePrice === 0 && (originalLinePrice === 0 || discountAmount > 0);
  }

  function validateManagedGifts(cart, desired) {
    var problems = [];
    CONFIG.gifts.forEach(function (gift) {
      var desiredQuantity = Number(desired[gift.key] || 0);
      if (!configuredVariantId(gift)) {
        if (desiredQuantity > 0) problems.push(gift.label + ' is not configured');
        return;
      }
      var lines = managedGiftLines(cart, gift);
      var allVariantLines = giftVariantLines(cart, gift);
      var actualQuantity = lines.reduce(function (total, item) {
        return total + Number(item.quantity || 0);
      }, 0);
      if (allVariantLines.length !== lines.length) {
        problems.push(gift.label + ' has an unverified duplicate line');
      }
      if (actualQuantity !== desiredQuantity) {
        problems.push(gift.label + ' quantity is not confirmed');
      }
      lines.forEach(function (item) {
        if (!giftLineIsFree(item)) problems.push(gift.label + ' is not fully discounted');
      });
    });
    return problems;
  }

  function loadEligibility(cart) {
    if (!Number(cart.item_count || 0) || !isPromotionActive()) {
      return Promise.resolve({ spindown: {}, poly: {} });
    }

    var inlineEligibility = readInlineEligibility(cart);
    if (inlineEligibility) return Promise.resolve(inlineEligibility);

    return Promise.all([
      loadCollectionProductIds(CONFIG.collections.spindown),
      loadCollectionProductIds(CONFIG.collections.poly)
    ]).then(function (sets) {
      return { spindown: sets[0], poly: sets[1] };
    });
  }

  function readInlineEligibility(cart) {
    var recordsByProductId = {};
    var nodes = document.querySelectorAll('[data-ib-promotion-eligibility]');
    for (var nodeIndex = 0; nodeIndex < nodes.length; nodeIndex += 1) {
      try {
        var records = JSON.parse(nodes[nodeIndex].textContent || '[]');
        records.forEach(function (record) {
          if (!record || record.productId == null) return;
          recordsByProductId[String(record.productId)] = record;
        });
      } catch (error) {
        console.error('[Gen Con promotion eligibility]', error);
      }
    }

    var nonGiftProductIds = {};
    (cart.items || []).forEach(function (item) {
      if (!isAnyGiftVariantLine(item)) nonGiftProductIds[String(item.product_id)] = true;
    });
    var productIds = Object.keys(nonGiftProductIds);
    if (!productIds.length || !productIds.every(function (productId) { return recordsByProductId[productId]; })) {
      return null;
    }

    var result = { spindown: {}, poly: {} };
    productIds.forEach(function (productId) {
      var record = recordsByProductId[productId];
      if (record.spindown === true) result.spindown[productId] = true;
      if (record.poly === true) result.poly[productId] = true;
    });
    return result;
  }

  function promotionCartNeedsGuard(cart, desired) {
    var hasDesiredGift = Object.keys(desired || {}).some(function (key) {
      return Number(desired[key] || 0) > 0;
    });
    return hasDesiredGift
      || hasLegacyAuthoritativeAttributes(cart)
      || (cart.items || []).some(function (item) { return isAnyGiftVariantLine(item); });
  }

  function setPromotionCartGuard(guarded) {
    if (guarded) {
      document.documentElement.setAttribute('data-ib-promotion-cart-guarded', 'true');
    } else {
      document.documentElement.removeAttribute('data-ib-promotion-cart-guarded');
    }
    document.querySelectorAll('[data-ib-cart-root], #CartDrawer').forEach(function (root) {
      if (guarded) root.setAttribute('data-ib-promotion-guarded', 'true');
      else root.removeAttribute('data-ib-promotion-guarded');
    });
    if (!guarded) {
      document.querySelectorAll('[data-ib-checkout]').forEach(function (button) {
        button.disabled = false;
        button.setAttribute('aria-disabled', 'false');
      });
      document.querySelectorAll('[data-ib-checkout-status]').forEach(function (status) {
        status.textContent = '';
      });
    }
  }

  function setGuardedCheckoutReady(ready, message) {
    document.querySelectorAll('[data-ib-promotion-guarded] [data-ib-checkout], html[data-ib-promotion-cart-guarded] [data-ib-checkout]').forEach(function (button) {
      button.disabled = !ready;
      button.setAttribute('aria-disabled', ready ? 'false' : 'true');
    });
    document.querySelectorAll('[data-ib-promotion-guarded] [data-ib-checkout-status], html[data-ib-promotion-cart-guarded] [data-ib-checkout-status]').forEach(function (status) {
      status.textContent = message || '';
    });
  }

  function setCheckoutPreparing(value) {
    checkoutPreparing = value;
    window.clearTimeout(timer);
    if (value) {
      document.documentElement.setAttribute('data-ib-checkout-preparing', 'true');
    } else {
      document.documentElement.removeAttribute('data-ib-checkout-preparing');
      if (pending) scheduleReconcile();
    }
  }

  function isCartMutationControl(target) {
    if (!target || !target.closest) return false;
    if (target.closest('[data-ib-checkout], button[name="checkout"]')) return false;
    var form = target.closest('form');
    if (form) {
      var action = String(form.getAttribute('action') || '');
      if (action.indexOf('/cart') !== -1) return true;
    }
    return Boolean(target.closest('a[href*="/cart/change"], a[href*="/cart/add"]'));
  }

  function refreshCartMarkup() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function reconcileGifts() {
    if (reconcilePromise) {
      pending = true;
      return reconcilePromise;
    }

    reconcilePromise = (async function () {
      var latestCart;
      do {
        pending = false;
        var cart = await getCart();
        var eligibility = await loadEligibility(cart);
        var desired = desiredGiftQuantities(cart, eligibility);
        setPromotionCartGuard(promotionCartNeedsGuard(cart, desired));
        var plan = buildReconciliationPlan(cart, desired);
        var changed = false;

        if (Object.keys(plan.updates).length) {
          await updateGiftLines(plan.updates);
          changed = true;
        }
        if (plan.additions.length) {
          await addGiftLines(plan.additions);
          changed = true;
        }
        if (changed) refreshCartMarkup();
        latestCart = changed ? await getCart() : cart;
        if (hasLegacyAuthoritativeAttributes(latestCart)) {
          latestCart = await updateCartAttributes();
        }
        setPromotionCartGuard(promotionCartNeedsGuard(latestCart, desired));

        if (plan.missingConfiguration.length) {
          throw new Error('Promotion gift configuration is incomplete: ' + plan.missingConfiguration.join(', ') + '.');
        }
      } while (pending);
      return latestCart;
    }());

    return reconcilePromise.finally(function () {
      reconcilePromise = null;
      if (pending) scheduleReconcile();
    });
  }

  async function prepareCheckout() {
    if (checkoutPromise) return checkoutPromise;

    checkoutPromise = (async function () {
      for (var attempt = 0; attempt < 5; attempt += 1) {
        await reconcileGifts();
        var before = await getCart();
        var eligibility = await loadEligibility(before);
        var expected = desiredGiftQuantities(before, eligibility);
        var beforeProblems = validateManagedGifts(before, expected);
        if (beforeProblems.length) {
          pending = true;
          continue;
        }

        await updateCartAttributes();
        var after = await getCart();
        eligibility = await loadEligibility(after);
        expected = desiredGiftQuantities(after, eligibility);
        var afterProblems = validateManagedGifts(after, expected);
        if (cartSignature(before) === cartSignature(after)
          && !afterProblems.length
          && auditAttributeMatches(after)) {
          return after;
        }
        pending = true;
      }

      throw new Error('The cart changed while promotional gifts were being confirmed.');
    }());

    return checkoutPromise.finally(function () {
      checkoutPromise = null;
    });
  }

  function scheduleReconcile() {
    if (checkoutPreparing) {
      pending = true;
      return;
    }
    window.clearTimeout(timer);
    setGuardedCheckoutReady(false, 'Updating and verifying promotional rewards...');
    timer = window.setTimeout(function () {
      reconcileGifts().then(function () {
        setGuardedCheckoutReady(true, 'Promotional rewards verified.');
      }).catch(function (error) {
        console.error('[Gen Con promotional gifts]', error);
        setGuardedCheckoutReady(false, 'We could not verify promotional rewards. Please refresh and try again, or contact us for help.');
      });
    }, CONFIG.debounceMs);
  }

  function checkoutStatus(form) {
    return form.querySelector('[data-ib-checkout-status]');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var submitter = event.submitter || document.activeElement;
    var isCheckout = form && form.matches('form[action*="/cart"]')
      && submitter
      && (submitter.name === 'checkout' || submitter.matches('[data-ib-checkout]'));
    if (!isCheckout) return;
    if (checkoutBypassForm === form) {
      checkoutBypassForm = null;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    var originalLabel = submitter.textContent;
    var status = checkoutStatus(form);
    submitter.disabled = true;
    submitter.textContent = 'Confirming rewards...';
    if (status) status.textContent = 'Confirming that every eligible gift is present and free before checkout.';
    setCheckoutPreparing(true);

    prepareCheckout().then(function () {
      submitter.disabled = false;
      submitter.textContent = originalLabel;
      if (status) status.textContent = '';
      checkoutBypassForm = form;
      if (form.requestSubmit) {
        try {
          form.requestSubmit(submitter);
        } finally {
          window.setTimeout(function () {
            if (checkoutBypassForm === form) checkoutBypassForm = null;
            setCheckoutPreparing(false);
          }, 0);
        }
      } else {
        var checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = 'Checkout';
        form.appendChild(checkoutInput);
        form.submit();
      }
    }).catch(function (error) {
      console.error('[Gen Con checkout preparation]', error);
      checkoutBypassForm = null;
      setCheckoutPreparing(false);
      submitter.disabled = false;
      submitter.textContent = originalLabel;
      if (status) {
        status.textContent = 'We could not confirm that every promotional gift is present and free. Please try checkout again or contact us for help.';
        status.focus();
      }
    });
  }, true);

  ['click', 'input', 'change'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (!checkoutPreparing || !isCartMutationControl(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  });

  document.addEventListener('ajaxProduct:added', scheduleReconcile);
  document.addEventListener('cart:updated', scheduleReconcile);
  document.addEventListener('page:loaded', scheduleReconcile);

  function initialize() {
    if (document.querySelector('[data-ib-promotion-guarded]')) {
      setGuardedCheckoutReady(false, 'Updating and verifying promotional rewards...');
    }
    if (Number(bootstrap.cartItemCount || 0) > 0 || document.querySelector('[data-ib-cart-root]')) {
      scheduleReconcile();
    }
    schedulePromotionExpiryRefresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  window.InfiniteBlackGenConGift = {
    reconcile: reconcileGifts,
    prepareCheckout: prepareCheckout,
    config: CONFIG
  };
}());
